import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OnAccountAuthSucceededActionMessage {
    mailboxInfo: MailboxInfo;
}
const defaultExport: (mailboxInfo: MailboxInfo) => OnAccountAuthSucceededActionMessage = action(
    'onAccountAuthSucceeded',
    (mailboxInfo: MailboxInfo): OnAccountAuthSucceededActionMessage => ({
        mailboxInfo,
    })
);
export default defaultExport;
